"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/prefer-default-export, camelcase */
var combineLearningPanelUrl_1 = __importDefault(require("./combineLearningPanelUrl"));
var rest_1 = __importDefault(require("../../../rest"));
var homepageApi_1 = require("../../mock/learningPanel/homepageApi");
var HomepageAPIs = {
    getCompletionData: function () {
        return rest_1.default.get({
            mockFunc: function () { return homepageApi_1.mockCompletionData; },
            url: (0, combineLearningPanelUrl_1.default)('/homepage/assigned-completion'),
        });
    },
    getUsersLeaderboard: function (teamId, offset, limit, searchString) {
        return rest_1.default.get({
            mockFunc: function () { return (offset === 0 ? homepageApi_1.mockUsersLeaderboard : homepageApi_1.mockUsersLeaderboard2); },
            url: (0, combineLearningPanelUrl_1.default)("/homepage/users-leaderboard/?".concat(teamId ? "team_id=".concat(teamId, "&") : '', "limit=").concat(limit, "&offset=").concat(offset, "&search_string=").concat(searchString || '')),
        });
    },
    getTeamsLeaderboard: function (offset, limit, searchString) {
        return rest_1.default.get({
            mockFunc: function () { return homepageApi_1.mockTeamsLeaderboard; },
            url: (0, combineLearningPanelUrl_1.default)("/homepage/teams-leaderboard/?limit=".concat(limit, "&offset=").concat(offset, "&search_string=").concat(searchString || '')),
        });
    },
    getUserAchievements: function () {
        return rest_1.default.get({
            mockFunc: function () { return homepageApi_1.userAchievementsMock; },
            url: (0, combineLearningPanelUrl_1.default)('/homepage/user-achievements'),
        });
    },
};
exports.default = HomepageAPIs;
